var $ = require('jquery');
var _ = require('underscore');
var TorsoFormView = require('backbone-torso/modules/FormView');
var selectPaymentMethodTemplate = require('./selectPaymentMethodTemplate.hbs');
var selectDeviceOptionTemplate = require('./selectDeviceOptionTemplate.hbs');
var applicationUtils = require('./../applicationUtils');
var launcherAppInterface = require('./../launcherApplicationInterface');
var financialFeatureConfigModel = require('./../financial/financialFeatureConfigModel');
var PaymentDetailsFormModel = require('./PaymentDetailsFormModel');
var PaymentDetailsCreditCardView = require('./PaymentDetailsCreditCardView');
var PaymentDetailsAchView = require('./PaymentDetailsAchView');
var StoredPaymentMethodDataBehavior = require('./../payment-method/StoredPaymentMethodDataBehavior');
var billingConfigModel = require('./../financial/billingConfigModel');
var PaymentProcessingDeviceDataBehavior = require('./../financial/paymentProcessingDevice/PaymentProcessingDeviceDataBehavior');
var Select2Behavior = require('./../behaviors/Select2Behavior');
var userService = require('./../user/userService');
var paymentDataDeviceService = require('./paymentDataDeviceService');

var PAYMENT_METHODS = PaymentDetailsFormModel.PAYMENT_METHODS;

/**
 * View for selecting which payment method to use.
 *
 * @class SelectPaymentMethodView
 * @constructor
 * @param options {Object}
 *   @param options.patientVecnaId {String} the vecna id of the patient that the payment is being made for.
 */
module.exports = TorsoFormView.extend({
  tagName: 'section',
  template: selectPaymentMethodTemplate,

  events: {
    'click [data-refresh-stored-payments-button]': '_fetchStoredPaymentMethods',
    'click [data-refresh-payment-processing-devices-button]': '_fetchPaymentProcessingDevices',
    'focus input[type="radio"]': '_setFocusOutline',
    'focus input[type="checkbox"]': '_setFocusOutline',
    'blur input[type="radio"]': '_removeFocusOutline',
    'blur input[type="checkbox"]': '_removeFocusOutline',
    'keyup #store-payment_save-true': '_setFocusOnCardNickname',
    'click [data-payment-data-device-retry]': '_startPaymentDataDeviceAvailableStatusRetrieval'
  },

  /**
   * The view to handle credit card information associated with the current payment details.
   *
   * @property _creditCardView
   * @type PaymentDetailsCreditCardView
   * @private
   */
  _creditCardView: null,

  /**
   * The view to handle ACH information associated with the current payment details.
   *
   * @property _achView
   * @type PaymentDetailsAchView
   * @private
   */
  _achView: null,

  /**
   * ID for the patient this payment is for.
   * @property _patientVecnaId
   * @type String
   * @private
   */
  _patientVecnaId: null,

  prepareFields: {
    showPaymentProcessingDevices: '_showPaymentProcessingDeviceOption',

    noPaymentProcessingDevices: '_noPaymentProcessingDevicesActive',
    showPaymentDataDevices: '_showPaymentDataDeviceOption',

    DEVICE_SCAN_STATUS: paymentDataDeviceService.DEVICE_SCAN_STATUS,

    paymentDataDeviceAvailability: function() {
      return paymentDataDeviceService.get('paymentDataDevice.availability');
    },

    paymentDataDeviceNotFound: function() {
      return paymentDataDeviceService.isPaymentDataDeviceNotFound();
    },

    creditCardPaymentEnabled: function() {
      return financialFeatureConfigModel.isCreditCardPaymentEnabled();
    },
    achPaymentEnabled: function() {
      return financialFeatureConfigModel.isAchPaymentEnabled();
    },
    PAYMENT_METHODS: PAYMENT_METHODS,
    CARDS: PaymentDetailsFormModel.CARDS,
    storedPmtEnabledOnCurrentApp: function() {
      return financialFeatureConfigModel.storedPmtEnabledOnCurrentApp();
    },
    storedPaymentMethodContext: function() {
      var storedPaymentMethodModels = this.getBehavior('storedPaymentMethods').data.getModels();
      var validStoredPaymentMethodModels = _.filter(storedPaymentMethodModels, function(storedPaymentMethodModel) {
        return storedPaymentMethodModel.get('valid');
      });
      var storedPaymentMethodsExist = !_.isEmpty(validStoredPaymentMethodModels);
      if (storedPaymentMethodsExist) {
        var sharedContext = {
          CARDS: PaymentDetailsFormModel.CARDS,
          PAYMENT_METHODS: PAYMENT_METHODS,
          currentApplication: applicationUtils.currentApplication
        };
        return _.map(validStoredPaymentMethodModels, function(storedPaymentMethodModel) {
          var storedPaymentMethodItemContext = storedPaymentMethodModel.toJSON();
          // These redefinitions avoid some really ludicrous scoping issues in handlebars...
          _.extend(storedPaymentMethodItemContext, sharedContext);
          storedPaymentMethodItemContext.expirationYear = storedPaymentMethodModel.getExpirationYear();
          storedPaymentMethodItemContext.expirationMonth = storedPaymentMethodModel.getExpirationMonth();
          return storedPaymentMethodItemContext;
        });
      }
    },
    showPaymentSection: function() {
      var paymentEnabled = financialFeatureConfigModel.isPaymentEnabled();
      var storedPaymentMethodsExist = this._hasStoredPaymentMethods();
      return paymentEnabled || storedPaymentMethodsExist;
    },
    isAtHospital: function() {
      return launcherAppInterface.isAtHospital();
    }
   },

  injectionSites: {
    'credit-card': '_creditCardView',
    ach: '_achView'
  },

  behaviors: {
    select2: {
      behavior: Select2Behavior,
      select2Options: {
        templateResult: function (context) {
          var html = selectDeviceOptionTemplate(context);
          // Using jquery here is the only way I found to get around select2's html escaping of this content.
          // This makes it return a dom element instead of a string and the escaping is only on string content.
          return $(html);
        }
      }
    },
    storedPaymentMethods: {
      behavior: StoredPaymentMethodDataBehavior,
      alwaysFetch: true,
      renderOnFetch: true,
      updateEvents: ['view:financialConfigLoaded',
        'view._storedPaymentMethodService:payment-methods:updated',
        {'change': financialFeatureConfigModel}],
      ids: function (cache) {
        var isStoredPaymentMethodEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled();
        if (isStoredPaymentMethodEnabled) {
          return cache.fetchIdsForPatient(this.view._patientVecnaId);
        }
        return {
          skipObjectRetrieval: true,
          forceFetchedEvent: true
        };
      }
    },
    paymentProcessingDevices: {
      behavior: PaymentProcessingDeviceDataBehavior,
      renderOnFetch: true,
      updateEvents: ['view:billingConfigLoaded', {'change': billingConfigModel}],
      ids: function (cache) {
        var canMakePaymentProcessingDevicePayments = this.view._canMakePaymentProcessingDevicePmtsOnAdmin();

        if (!canMakePaymentProcessingDevicePayments) {
          return {
            skipObjectRetrieval: true,
            forceFetchedEvent: true
          };
        }

        // Get all active payment processing devices ordered by display name.
        var paymentProcessingDeviceCriteria = {
          active: true,
          pagingAndSorting: {
            orderingMap: {
              name: true
            }
          }
        };
        return cache.fetchIdsByCriteria(paymentProcessingDeviceCriteria)
          .then(function (response) {
            return response.list;
          });
      }
    }
  },

  /**
   * Configures feedback bindings.
   * @property feedback {Array of When/Then Feedbacks}
   */
  feedback: [
    {
      /**
       * On click of the payment method radio or submits, validate the payment method
       * and display the error feedback box if needed
       * @property feedback[0] (Payment Method Error) {When/Then Feedback}
       */
      when: {
        '@paymentMethod': ['change'],
        'on': ['submit']
      },
      then: function() {
        var errors = this.model.preValidate(['paymentMethod']);
        if (errors) {
          return {
            removeClass: 'brec-hidden',
            attr: ['aria-hidden', 'false']
          };
        } else {
          return {
            addClass: 'brec-hidden',
            attr: ['aria-hidden', 'true']
          };
        }
      },
      to: 'paymentMethodError'
    }, {
      /**
       * On click of the payment method radio or submits, validate the payment method
       * and add the error message if needed
       * @property feedback[1] (Payment Method Error Message) {When/Then Feedback}
       */
      when: {
        '@paymentMethod': ['change'],
        'on': ['submit']
      },
      then: function() {
        return this._thenFormatFeedback(this.model.preValidate('paymentMethod'), {
          'required.failed': 'paymentMethod.required'
        });
      },
      to: 'paymentMethodErrorMsg'
    }, {
      /**
       * On click of the payment method radio/checkbox,
       * Then remove existing focus container class,
       * And add it to the container of the selected radio/checkbox
       * @property feedback[2] (Payment Method Radio/Checkbox Container) {When/Then Feedback}
       */
      when: {
        '@paymentMethod': ['change']
      },
      then: function (event) {
        var focusContainer = this.$el.find('[data-focus-container]');
        if (focusContainer.hasClass('brec-form__focus-container')) {
          focusContainer.removeClass('brec-form__focus-container--focused');
        }
        var targetContainer = $(event.target).closest('[data-focus-container]');
        targetContainer.addClass('brec-form__focus-container--focused');
      },
      to: 'paymentMethod'
    }
  ],

  /**
   * @method initialize
   * @param options {Object}
   *   @param options.patientVecnaId {String} the vecna id of the patient that the payment is being made for.
   *   @param options.storedPaymentMethodService {StoredPaymentMethodService} the stored payment method service to user.
   *   @param options.paymentDetailsFormModel {PaymentDetailsFormModel} the form model for payments.
   */
  initialize: function (options) {
    options = options || {};
    _.bindAll(this, '_setFinancialConfigLoaded', '_setPaymentDefaults', '_setBillingConfigLoaded',
                    '_fetchStoredPaymentMethods', '_fetchPaymentProcessingDevices',
                    '_startPaymentDataDeviceAvailableStatusRetrieval');

    this._patientVecnaId = options.patientVecnaId;
    this._storedPaymentMethodService = options.storedPaymentMethodService;

    // Initialize the form model used by this view's child form views.
    var paymentDetailsFormModel = options.paymentDetailsFormModel;
    this.model = paymentDetailsFormModel;

    this.set('hide:payment-data-device', true);

    // Instantiate the credit card information child view.
    this._creditCardView = new PaymentDetailsCreditCardView({
      model: paymentDetailsFormModel,
      patientVecnaId: this._patientVecnaId
    });
    this.set('hide:credit-card', true);

    // Instantiate the ACH information child view.
    this._achView = new PaymentDetailsAchView({
      model: paymentDetailsFormModel,
      patientVecnaId: this._patientVecnaId
    });
    this.set('hide:ach', true);

    this.on('submit', this._submit);

    this.listenTo(paymentDetailsFormModel, 'change:paymentMethod', this._activatePaymentMethod);
    this.listenTo(this.viewState, 'change:hide:payment-processing-device', this.render);

    var storedPaymentMethodDataBehavior = this.getBehavior('storedPaymentMethods');
    this.listenTo(storedPaymentMethodDataBehavior, 'fetched', this._setPaymentDefaults);
    var paymentProcessingDeviceBehavior = this.getBehavior('paymentProcessingDevices');
    this.listenTo(paymentProcessingDeviceBehavior, 'fetched', this._setPaymentDefaults);
    paymentDataDeviceService.clearPaymentDataDeviceAvailability();
    this.listenTo(paymentDataDeviceService, 'change:paymentDataDevice.availability', this._setPaymentDefaults);
    this.listenTo(paymentDataDeviceService, 'change:paymentDataDevice.availability', this.render);
    financialFeatureConfigModel.loadOnce()
      .then(this._setPaymentDefaults)
      .then(this._setFinancialConfigLoaded)
      .then(this._fetchStoredPaymentMethods);
    billingConfigModel.loadOnce()
      .then(this._startPaymentDataDeviceAvailableStatusRetrieval)
      .then(this._setPaymentDefaults)
      .then(this._setBillingConfigLoaded)
      .then(this._fetchPaymentProcessingDevices);
  },

  /**
   * Sets the given payment method view as active (for validation).
   * @method _activatePaymentMethod
   * @private
   */
  _activatePaymentMethod: function() {
    var paymentMethod = this.model.get('paymentMethod');
    if (paymentMethod === PAYMENT_METHODS.paymentProcessingDevice && this._canMakePaymentProcessingDevicePmtsOnAdmin()) {
      var existingPaymentProcessingDeviceId = this.model.get('paymentDeviceId');
      var currentAdminUser = userService.currentAdminUserModel;
      if (!existingPaymentProcessingDeviceId && currentAdminUser) {
        this.model.set('paymentDeviceId', currentAdminUser.get('preferredDeviceId'));
      }

      this.set({
        'hide:payment-processing-device': false,
        'hide:credit-card': true,
        'hide:ach': true
      });
    } else if (paymentMethod === PAYMENT_METHODS.creditCard && financialFeatureConfigModel.isCreditCardPaymentEnabled()) {
      this._creditCardView.activate();
      this._achView.deactivate();
      this.set({
        'hide:payment-processing-device': true,
        'hide:credit-card': false,
        'hide:ach': true
      });
    } else if (paymentMethod === PAYMENT_METHODS.ach && financialFeatureConfigModel.isAchPaymentEnabled()) {
      this._creditCardView.deactivate();
      this._achView.activate();
      this.set({
        'hide:payment-processing-device': true,
        'hide:credit-card': true,
        'hide:ach': false
      });
    } else {
      this._creditCardView.deactivate();
      this._achView.deactivate();
      this.set({
        'hide:payment-processing-device': true,
        'hide:credit-card': true,
        'hide:ach': true
      });
    }
  },

  /**
   * Marks that the financial feature config has finished loading
   * @method setFinancialConfigLoaded
   * @private
   */
  _setFinancialConfigLoaded: function() {
    this.trigger('financialConfigLoaded');
  },

  /**
   * Marks that the billing feature config has finished loading
   * @method _setBillingConfigLoaded
   * @private
   */
  _setBillingConfigLoaded: function() {
    this.trigger('billingConfigLoaded');
  },

  /**
   * @method _hasStoredPaymentMethods
   * @return {Boolean} true if there are sto
   * @private
   */
  _hasStoredPaymentMethods: function() {
    var storedPaymentMethods = this.getBehavior('storedPaymentMethods').data.getModels();
    return !_.isEmpty(storedPaymentMethods);
  },

  /**
   * Set default payment method
   * @method _setPaymentDefaults
   * @private
   */
  _setPaymentDefaults: function() {
    var creditCardPaymentEnabled = financialFeatureConfigModel.isCreditCardPaymentEnabled();
    var achPaymentEnabled = financialFeatureConfigModel.isAchPaymentEnabled();
    var paymentProcessingDevicePaymentsEnabled = this._showPaymentProcessingDeviceOption() && this._hasPaymentProcessingDevices();
    var tabletDevicePaymentsEnabled = this._showPaymentDataDeviceOption() && paymentDataDeviceService.hasSelectedPaymentDataDevice();
    var storedPaymentMethodEnabled = financialFeatureConfigModel.isStoredPaymentMethodsEnabled();
    var storedPaymentMethods = storedPaymentMethodEnabled && this.getBehavior('storedPaymentMethods').data.getModels();
    var storedPaymentMethodsExist = !_.isEmpty(storedPaymentMethods);
    var defaultStoredPaymentMethod = _.find(storedPaymentMethods, function (storedPaymentMethod) {
      return storedPaymentMethod.get('defaultPaymentMethod') && storedPaymentMethod.get('valid');
    });
    var storedPaymentEnabledOnCurrentApp = financialFeatureConfigModel.storedPmtEnabledOnCurrentApp();

    // If we are in an inconsistent state (say something was selected before it was made unavailable)
    //   then unselect it before running the rest of this method.
    var selectedPaymentMethod = this.model.get('paymentMethod');
    var creditCardIncorrectlySelected = selectedPaymentMethod === PAYMENT_METHODS.creditCard && !creditCardPaymentEnabled;
    var achIncorrectlySelected = selectedPaymentMethod === PAYMENT_METHODS.ach && !achPaymentEnabled;
    var paymentProcessingDeviceIncorrectlySelected = selectedPaymentMethod === PAYMENT_METHODS.paymentProcessingDevice && !paymentProcessingDevicePaymentsEnabled;
    var paymentDataDeviceIncorrectlySelected = selectedPaymentMethod === PAYMENT_METHODS.paymentDataDevice && !tabletDevicePaymentsEnabled;
    var storedPaymentMethodIncorrectlySelected = PAYMENT_METHODS.isStoredPaymentMethod(selectedPaymentMethod) && !storedPaymentEnabledOnCurrentApp;
    var somethingIncorrectlySelected = creditCardIncorrectlySelected
                                    || achIncorrectlySelected
                                    || paymentProcessingDeviceIncorrectlySelected
                                    || paymentDataDeviceIncorrectlySelected
                                    || storedPaymentMethodIncorrectlySelected;

    if (somethingIncorrectlySelected) {
      this.model.unset('paymentMethod');
    }

    if (!financialFeatureConfigModel.get('enabled')) {
      return;
    }

    var countOfPaymentOptionsAvailable = 0;

    if (tabletDevicePaymentsEnabled) {
      ++countOfPaymentOptionsAvailable;
    }
    if (paymentProcessingDevicePaymentsEnabled) {
      ++countOfPaymentOptionsAvailable;
    }
    if (creditCardPaymentEnabled) {
      ++countOfPaymentOptionsAvailable;
    }
    if (achPaymentEnabled) {
      ++countOfPaymentOptionsAvailable;
    }
    if (storedPaymentMethodsExist) {
      countOfPaymentOptionsAvailable += 2;
    }

    // Unset the pre-selected default if payment selection was not enabled the last time this method was run.
    // (i.e. we had to preselect last time we clear that since the decision may have changed)
    var previousPaymentSelectionEnabled = this.get('paymentSelectionEnabled');
    if (!previousPaymentSelectionEnabled) {
      this.model.unset('paymentMethod');
    }

    var paymentSelectionEnabled = countOfPaymentOptionsAvailable > 1;
    this.set('paymentSelectionEnabled', paymentSelectionEnabled);
    //if not allowing user to choose payment method, make sure model knows which one we're defaulting to
    if (!paymentSelectionEnabled) {
      var preSelectedPaymentMethod;
      if (tabletDevicePaymentsEnabled) {
        preSelectedPaymentMethod = PAYMENT_METHODS.paymentDataDevice;
      } else if (paymentProcessingDevicePaymentsEnabled) {
        preSelectedPaymentMethod = PAYMENT_METHODS.paymentProcessingDevice;
      } else if (creditCardPaymentEnabled) {
        preSelectedPaymentMethod = PAYMENT_METHODS.creditCard;
      } else if (achPaymentEnabled) {
        preSelectedPaymentMethod = PAYMENT_METHODS.ach;
      }
      if (preSelectedPaymentMethod) {
        this.model.set('paymentMethod', preSelectedPaymentMethod);
      }
    }

    if (!this.model.get('paymentMethod') && tabletDevicePaymentsEnabled) {
      this.model.set('paymentMethod', PAYMENT_METHODS.paymentDataDevice);
    }

    var devicePaymentMethodDefaulted = this.get('devicePaymentMethodDefaulted');
    if (paymentProcessingDevicePaymentsEnabled && !devicePaymentMethodDefaulted) {
      this.model.set('paymentMethod', PAYMENT_METHODS.paymentProcessingDevice);
      this.set('devicePaymentMethodDefaulted', true);
    }

    // Only default the stored payment method one time once we have a default stored payment method
    var storedPaymentMethodDefaulted = this.get('storedPaymentMethodDefaulted');
    if (defaultStoredPaymentMethod && !storedPaymentMethodDefaulted && storedPaymentEnabledOnCurrentApp) {
      this.model.set('paymentMethod', defaultStoredPaymentMethod.get('vecnaId'));
      this.set('storedPaymentMethodDefaulted', true);
    }
  },

  /**
   * Validate sub-views (credit card and ach) and that a payment method is selected.
   * @method _submit
   * @private
   */
  _submit: function() {
    var paymentMethod = this.model.get('paymentMethod');
    if (paymentMethod === PAYMENT_METHODS.creditCard) {
      // This will trigger the 'paymentDataReady' event on the model
      // when the payment data has been validated and is ready for making the payment.
      this._creditCardView.trigger('submit');
    } else if (paymentMethod === PAYMENT_METHODS.ach) {
      // This will trigger the 'paymentDataReady' event on the model
      // when the payment data has been validated and is ready for making the payment.
      this._achView.trigger('submit');
    } else {
      // No views to validate via the 'submit' event,
      // so just trigger that the payment data is ready.
      this.model.trigger('paymentDataReady');
    }
  },

  /**
   * A method to fetch stored payment methods.
   * @method _fetchStoredPaymentMethods
   * @private
   */
  _fetchStoredPaymentMethods: function() {
    this.getBehavior('storedPaymentMethods').fetch();
  },

  // START - Payment Data Device methods

  /**
   * Determine if payment data device payments option should be shown.
   * @method _showPaymentDataDeviceOption
   * @returns {*|boolean}
   * @private
   */
  _showPaymentDataDeviceOption: function() {
    var currentConfig = billingConfigModel.getCurrentProcessorConfig();
    var isTabletDeviceProcessor = currentConfig && currentConfig.supportsTabletPayment;
    var isPaymentDataDeviceEnabledOnTablet = paymentDataDeviceService.isPaymentDataDeviceEnabled();
    return launcherAppInterface.isAtHospital() && isTabletDeviceProcessor && isPaymentDataDeviceEnabledOnTablet;
  },

  /**
   * @method _startPaymentDataDeviceAvailableStatusRetrieval
   * @private
   */
  _startPaymentDataDeviceAvailableStatusRetrieval: function() {
    var processorName = billingConfigModel.get('paymentProcessorName');
    paymentDataDeviceService.startDeviceAvailabilityRetrieval(processorName);
  },

  /**
   * @method _canMakePaymentProcessingDevicePmtsOnAdmin
   * @return {boolean} whether payments are enabled via processing device and should be shown.
   * @private
   */
  _canMakePaymentProcessingDevicePmtsOnAdmin: function() {
    var isAdminBillpayEnabled = billingConfigModel.get('staffBillpayEnabled');
    var isAdminTool = applicationUtils.currentApplication === applicationUtils.APPLICATIONS.ADMIN_TOOL;

    return isAdminBillpayEnabled && isAdminTool;
  },

  // END - Payment Data Device methods

  // START - Payment Processing Device methods

  /**
   * A method to fetch payment processing devices.
   * @method _fetchPaymentProcessingDevices
   * @private
   */
  _fetchPaymentProcessingDevices: function() {
    this.getBehavior('paymentProcessingDevices').fetch();
  },

  /**
   * Determine if payment processing device option should be shown.
   * @method _showPaymentProcessingDeviceOption
   * @returns {*|boolean}
   * @private
   */
  _showPaymentProcessingDeviceOption: function() {
    var canMakeDevicePayments = this._canMakePaymentProcessingDevicePmtsOnAdmin();
    var paymentDevicesBehavior = this.getBehavior('paymentProcessingDevices');
    var devicesStillInitiallyLoading = paymentDevicesBehavior.data.isLoading() && !paymentDevicesBehavior.get('fetchedOnce');

    return canMakeDevicePayments && !devicesStillInitiallyLoading;
  },

  /**
   * Determine if payment processing devices are available.
   * @method _hasPaymentProcessingDevices
   * @returns {*|boolean}
   * @private
   */
  _hasPaymentProcessingDevices: function() {
    var paymentProcessingDevices = this.getBehavior('paymentProcessingDevices');

    return paymentProcessingDevices.data.getModels().length > 0;
  },

  /**
   * Determine if there is a payment processing device active
   * @method _noPaymentProcessingDevicesActive
   * @returns {boolean}
   * @private
   */
  _noPaymentProcessingDevicesActive: function() {
    var devicePaymentOptionShown = this._showPaymentProcessingDeviceOption();
    var hasPaymentDevices = this._hasPaymentProcessingDevices();

    return devicePaymentOptionShown && !hasPaymentDevices;
  },

  // END - Payment Processing Device methods

  /**
   * A method to add focus container class to the container of
   * a radio/checkbox when it receives focus.
   * @method _setFocusOutline
   * @private
   */
  _setFocusOutline: function(event) {
    $(event.target).closest('[data-focus-container]').addClass('brec-form__focus-container--focused');
  },

  /**
   * A method to remove focus container class of the container of
   * a radio/checkbox when it loses focus
   * @method _removeFocusOutline
   * @private
   */
  _removeFocusOutline: function(event) {
    $(event.target).closest('[data-focus-container]').removeClass('brec-form__focus-container--focused');
  },

  /**
   * Correctly times calls so that Jasmine tests received data in proper order
   * @method __getAllConfigsLoadedPromiseForTesting
   * @returns {*}
   * @private
   */
  __getAllConfigsLoadedPromiseForTesting: function() {
    var storedPaymentMethodDataBehavior = this.getBehavior('storedPaymentMethods');
    var storedPaymentMethodPromise = storedPaymentMethodDataBehavior.fetch();
    var deviceDataBehavior = this.getBehavior('paymentProcessingDevices');
    var deviceDataBehaviorPromise = deviceDataBehavior.fetch();
    var billingConfigModelPromise = billingConfigModel.fetch();

    var allLoadedDeferred = $.Deferred();
    $.when(storedPaymentMethodPromise, deviceDataBehaviorPromise, billingConfigModelPromise)
      .then(function() {
        // need to pop this out of the current execution thread because the behaviors haven't actually loaded their data
        // from within this promise.
        window.setTimeout(function() {
          allLoadedDeferred.resolve();
        }, 1);
      },
      allLoadedDeferred.reject);

    return allLoadedDeferred.promise();
  },

  /**
   * reset model for Jasmine testing
   * @method __resetForTesting
   * @private
   */
  __resetForTesting: function() {
    this.model.unset('paymentMethod');
    this.unset('storedPaymentMethodDefaulted');
    this.unset('devicePaymentMethodDefaulted');
    paymentDataDeviceService._clearTimeoutsAndIntervals();
  }
});
